import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SolanaProvider } from './contexts/solanaContext';
import { SolanaWalletProvider } from './contexts/solanaWalletContext';
import store from './store'


// Configure Solana Connection
const network = clusterApiUrl('mainnet-beta'); // You can change 'devnet' to 'mainnet-beta' as needed
const wallets = [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    // ... add other Solana wallets here if needed
];
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

      <ConnectionProvider endpoint={network}>
        <WalletProvider wallets={wallets} autoConnect>
          <SolanaProvider>
            <Provider store={store}>
             <App />
            </Provider>
          </SolanaProvider>
        </WalletProvider>
      </ConnectionProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
